import invokeApi from './../util/apiclient'
export const GET_STAGES = 'GET_STAGES'
export const GET_STAGE = 'GET_STAGE'

export function getStages () {
    return (dispatch) => {
        return invokeApi('GET', '/stages/')
            .then((response) => {
                dispatch({ type: GET_STAGES + '/SUCCESS', result: response.data })
            }).catch((result) => {
                dispatch({ type: GET_STAGES + '/FAILED' })                
            })
    }
}

export function getStage (stageId) {
  return (dispatch) => {
      return invokeApi('GET', '/stages/{stageId}/detailed', {stageId})
          .then((response) => {
              dispatch({ type: GET_STAGE + '/SUCCESS', result: response.data })
          }).catch((result) => {
              dispatch({ type: GET_STAGE + '/FAILED' })                
          })
  }
}